import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './state';

export const progressSlice = createSlice({
    name: 'progressSlice',
    initialState,
    reducers: {
        setProgress: (state, action: PayloadAction<number>) => {
            state.progress = action.payload;
        },
    },
});

export const { setProgress } = progressSlice.actions;
export default progressSlice.reducer;
